import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import TokenService from "../../../api/services/TokenService";
import api from "../../../api/api";
import { USER } from "../../../api/queryKeys";

export default function useCreateUser({
  onSuccessHandler,
}: {
  onSuccessHandler?: () => void;
}) {
  return useMutation(
    ({
      email,
      password,
      firstName,
      lastName,
    }: {
      email: string;
      password: string;
      firstName: string;
      lastName: string;
    }) =>
      api
        .post(USER, {
          email,
          password,
          first_name: firstName,
          last_name: lastName,
          user_type: "admin",
        })
        .then((res) => res.data),
    {
      onError: (error) => {
        toast.error("Unable to create account. Please try again.");
      },
      onSuccess: (data) => {
        TokenService.storeAuthTokensInLocalStorage(data.access, data.refresh);
        if (onSuccessHandler) {
          onSuccessHandler();
        }
      },
    }
  );
}
